import { useMemo, useState } from "react";
import { projects } from "../data/projects";
import type { Project, ProjectCategory } from "../types";
import { useI18n } from "../i18n/LanguageContext";
import { ProjectCard } from "./ProjectCard";
import { ProjectDetails } from "./ProjectDetails";
import { Modal } from "./Modal";
import { SectionHead } from "./SectionHead";
import styles from "./Portfolio.module.css";
import cards from "./cards.module.css";

type Filter = "all" | ProjectCategory;

export function Portfolio() {
  const { ui } = useI18n();
  const [filter, setFilter] = useState<Filter>("all");
  const [active, setActive] = useState<Project | null>(null);

  const filters: { value: Filter; label: string }[] = [
    { value: "all", label: ui.portfolio.filters.all },
    { value: "open-source", label: ui.portfolio.filters.openSource },
    { value: "commercial", label: ui.portfolio.filters.commercial },
  ];

  const visible = useMemo(
    () =>
      filter === "all"
        ? projects
        : projects.filter((p) => p.category === filter),
    [filter],
  );

  return (
    <section id="work" className="section solid">
      <div className="container">
        <SectionHead
          eyebrow={ui.portfolio.eyebrow}
          title={ui.portfolio.title}
          sub={ui.portfolio.sub}
        />

        <div className={styles.filters} role="tablist" aria-label={ui.portfolio.eyebrow}>
          {filters.map((option) => (
            <button
              key={option.value}
              type="button"
              role="tab"
              aria-selected={filter === option.value}
              className={`${styles.filter} ${
                filter === option.value ? styles.filterActive : ""
              }`}
              onClick={() => setFilter(option.value)}
            >
              {option.label}
            </button>
          ))}
        </div>

        <div className={cards.grid}>
          {visible.map((project) => (
            <ProjectCard key={project.id} project={project} onOpen={setActive} />
          ))}
        </div>
      </div>

      {active && (
        <Modal title={active.title} onClose={() => setActive(null)}>
          <ProjectDetails project={active} />
        </Modal>
      )}
    </section>
  );
}
